import { configureStore } from "@reduxjs/toolkit";
import requestDemoReducer from "../models/requestDemoSlice";
import authReducer from "../models/authSlice";
import generateReducer from "../models/generateSlice";
import projectHistoryReducer from "../models/projectHistorySlice";

export const store = configureStore({
  reducer: {
    requestDemo: requestDemoReducer,
    auth: authReducer,
    generate: generateReducer,
    projectHistory: projectHistoryReducer,
  },
});
